import React from 'react';
import SubscribeThanksForm from './subscribe/SubscribeThanksForm';

function SubscribeEmailThanks({ size }) {
  return (
    <SubscribeThanksForm size={size}>
      <p className={`subscribe-${size}-thanks-lead`}>Thanks for Subscribing!</p>
      <p className={`subscribe-${size}-thanks-message`}>We look forward to<br />delighting your inbox<br />with delectable bytes<br />soon!</p>
    </SubscribeThanksForm>
  );
}

export default SubscribeEmailThanks;
